import type { PreferredFormat } from '../types/api';

/**
 * Lightweight localStorage-backed user preferences.
 * Anything that should persist across reloads but not across users
 * (e.g., last-used composer format) goes here.
 */

const KEY = 'wb-hub:prefs:v1';

export interface Preferences {
  defaultFormat: PreferredFormat;
  sidebarOpen: boolean;
  reducedAnimation: boolean;
}

const DEFAULTS: Preferences = {
  defaultFormat: 'auto',
  sidebarOpen: true,
  reducedAnimation: false,
};

export function loadPreferences(): Preferences {
  if (typeof window === 'undefined') return DEFAULTS;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw) as Partial<Preferences>;
    return { ...DEFAULTS, ...parsed };
  } catch {
    return DEFAULTS;
  }
}

export function savePreferences(patch: Partial<Preferences>): Preferences {
  const current = loadPreferences();
  const next = { ...current, ...patch };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore quota / disabled */
  }
  return next;
}
